import React from 'react';
import type { ReactNode } from 'react';
import { AuthProvider } from './AuthProvider';
import { NotificationProvider } from './NotificationProvider';
import { PractitionerFilterProvider } from './PractitionerFilterProvider';
import { ProspectFilterProvider } from './ProspectFilterProvider';
import { QueryProvider } from './QueryProvider';
import { ThemeModeProvider } from './ThemeModeProvider';
import { UIProvider } from './UIProvider';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <ThemeModeProvider>
        <NotificationProvider>
          <AuthProvider>
            <UIProvider>
              <PractitionerFilterProvider>
                <ProspectFilterProvider>{children}</ProspectFilterProvider>
              </PractitionerFilterProvider>
            </UIProvider>
          </AuthProvider>
        </NotificationProvider>
      </ThemeModeProvider>
    </QueryProvider>
  );
}
